import type { LogFilters } from '../types/index';

export const getDefaultFilters = (): LogFilters => {
    // Calculate 6 hours ago from now
    const now = new Date();
    const sixHoursAgo = new Date(now.getTime() - 6 * 60 * 60 * 1000);

    return {
        dateFrom: sixHoursAgo.toISOString(),
        dateTo: now.toISOString(),
        level: ['error', 'warn'], // High severity levels matching Logger interface
        severityThreshold: [7, 8, 9, 10] // High severity thresholds (7-10) matching Logger interface
    };
};
